import type { SVGProps } from 'react'

const svgProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true as const,
}

/** 生图：绘制 / 铅笔 */
export function IconNavCreate(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <path d="m15 5 4 4-9 9-4 1 1-4 9-9Z" />
      <path d="M13 7l4 4" />
    </svg>
  )
}

/** 漫画：竖版书脊 */
export function IconNavComic(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <path d="M6 4h5v16H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z" />
      <path d="M11 3h5v18h-3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
      <path d="M16 5h4v14h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z" />
      <path d="M8 8h2M13 7h2" />
    </svg>
  )
}

/** 工作流：节点与连线 */
export function IconNavWorkflow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <rect x="3" y="4" width="6" height="6" rx="1.5" />
      <rect x="15" y="4" width="6" height="6" rx="1.5" />
      <rect x="9" y="15" width="6" height="6" rx="1.5" />
      <path d="M9 7h6" />
      <path d="M18 10v2a3 3 0 0 1-3 3h-3" />
      <path d="M6 10v2a3 3 0 0 0 3 3h3" />
    </svg>
  )
}

/** 智能体：机器人 */
export function IconNavAgent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <path d="M12 3.5v2" />
      <circle cx="12" cy="3" r="0.85" />
      <rect x="6.5" y="5.5" width="11" height="9.5" rx="2" />
      <circle cx="9.5" cy="10" r="1" />
      <circle cx="14.5" cy="10" r="1" />
      <path d="M9.25 13h5.5" />
      <path d="M4.5 9.5v3" />
      <path d="M19.5 9.5v3" />
      <path d="M9 15v3.5" />
      <path d="M15 15v3.5" />
    </svg>
  )
}

/** 图库：画框叠放 */
export function IconNavLibrary(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M3 16l5-5 4 4 3-3 6 6" />
      <circle cx="8.5" cy="8.5" r="1.5" />
    </svg>
  )
}

/** 套餐：卡片 */
export function IconNavPlans(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
    </svg>
  )
}

/** 我的：用户 */
export function IconNavProfile(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M5 20v-1a7 7 0 0 1 14 0v1" />
    </svg>
  )
}

/** 登录：挂锁 */
export function IconNavLogin(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  )
}

/** 设置：齿轮 */
export function IconNavSettings(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" {...svgProps} {...props}>
      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.14.31.22.65.22 1v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
    </svg>
  )
}

const svgSmall = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  width: 16,
  height: 16,
  'aria-hidden': true as const,
}

/** 图库侧栏：查看该分类下全部文件夹（网格 = 汇总视图） */
export function IconLibraryAllFolders(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} fill="none" {...props}>
      <rect x="3" y="3" width="7" height="7" rx="1.25" />
      <rect x="14" y="3" width="7" height="7" rx="1.25" />
      <rect x="3" y="14" width="7" height="7" rx="1.25" />
      <rect x="14" y="14" width="7" height="7" rx="1.25" />
    </svg>
  )
}

/** 图库侧栏：单个文件夹 */
export function IconLibraryFolder(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  )
}

/** 新建文件夹 */
export function IconFolderPlus(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
      <path d="M12 11v6M9 14h6" />
    </svg>
  )
}

/** 删除文件夹（与「删除图片」垃圾桶区分） */
export function IconFolderTrash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
      <path d="M9 14h6" />
    </svg>
  )
}

/** 移动到文件夹 */
export function IconMoveToFolder(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v3" />
      <path d="M3 7v10a2 2 0 0 0 2 2h7" />
      <path d="M16 15h5" />
      <path d="m19 12 3 3-3 3" />
    </svg>
  )
}

/**
 * 交换 / 映射（Lucide half-arrow-left-right：横向双轨，仅外侧半边箭头）
 * @see https://github.com/lucide-icons/lucide/pull/4277
 */
export function IconSwapHalfHorizontal(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M15 17.5 21.5 14" />
      <path d="M2.5 10 21.5 10" />
      <path d="M2.5 10 9 6.5" />
      <path d="M2.5 14 21.5 14" />
    </svg>
  )
}

/** 多选 / 勾选状态 */
export function IconCheckSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M20 6 9 17l-5-5" />
    </svg>
  )
}

/** 进入多选 / 编辑模式（虚线框） */
export function IconSelectionMode(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <rect
        width="17"
        height="17"
        x="3.5"
        y="3.5"
        rx="2"
        ry="2"
        fill="none"
        stroke="currentColor"
        strokeDasharray="2.75 2"
      />
    </svg>
  )
}

/** 缩略图角标：全屏预览 */
export function IconEyeSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  )
}

/** 新建 / 添加（通用加号） */
export function IconPlusSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  )
}

/** 关闭 / 取消 */
export function IconCloseSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </svg>
  )
}

/** 树形展开 */
export function IconChevronRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="m9 18 6-6-6-6" />
    </svg>
  )
}

/** 树形收起 */
export function IconChevronDown(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="m6 9 6 6 6-6" />
    </svg>
  )
}

/** 清空记录 / 删除 */
export function IconTrash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M3 6h18" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      <path d="M10 11v6M14 11v6" />
    </svg>
  )
}

/** 编辑 / 重命名 */
export function IconDownloadSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.75" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 3v10m0 0 3.5-3.5M10 13 6.5 9.5" />
      <path strokeLinecap="round" d="M4 17h12" />
    </svg>
  )
}

export function IconPencil(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
  )
}

/** 图库：管理分类 / 文件夹（列表整理，与铅笔、导航图标区分） */
export function IconLibraryManage(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <circle cx="5" cy="7" r="1.35" />
      <circle cx="5" cy="12" r="1.35" />
      <circle cx="5" cy="17" r="1.35" />
      <path d="M10 7h11M10 12h11M10 17h8" />
    </svg>
  )
}

/** 模板 */
export function IconTemplate(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <path d="M3 9h18" />
      <path d="M9 21V9" />
    </svg>
  )
}

/** 上传参考图：上箭头进托盘 */
export function IconUploadSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M12 15V5" />
      <path d="m8.5 8.5 3.5-3.5 3.5 3.5" />
      <path d="M4 15.5v3a2.5 2.5 0 0 0 2.5 2.5h11A2.5 2.5 0 0 0 20 18.5v-3" />
    </svg>
  )
}

/** 生成结果超清：四角外扩 + 内框示意放大 */
export function IconOutputSuperResolution(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <path d="M4 7V4h3M4 17v3h3M17 4h3v3M17 20h3v-3" />
      <rect x="8" y="8" width="8" height="8" rx="1.5" />
    </svg>
  )
}

/** 管理模板：叠放卡片（与单行「模板」芯片区分） */
export function IconTemplateManage(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...svgSmall} {...props}>
      <rect x="5.5" y="3.5" width="13" height="10" rx="1.5" />
      <path d="M8 6.5h8M8 9h5" />
      <rect x="3.5" y="7.5" width="13" height="10" rx="1.5" />
    </svg>
  )
}
